import config from "../../app.json";
import axios from "axios";

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import FieldText from "../../Components/Fields/FieldText";
import FieldSelect from "../../Components/Fields/FieldSelect";
import FieldProfileUpload from "../../Components/Fields/FieldProfileUpload";

import { Row, Col, Button } from "react-bootstrap";
import isEmpty from "lodash/isEmpty";

import AlertComponent from "../../Components/AlertComponent";
import "./Styles/user-detail.scss";

function UserDetail(props) {
  const { id } = useParams();

  let navigate = useNavigate();

  const [firstName, setFirstName] = useState(null);
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [lastNameError, setLastNameError] = useState(null);
  const [email, setEmail] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [password, setPassword] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [repeatPassword, setRepeatPassword] = useState(null);
  const [repeatPasswordError, setRepeatPasswordError] = useState(null);
  const [data, setData] = useState(null);
  const [eventsOptions, setEventsOptions] = useState([]);
  const [events, setEvents] = useState([]);

  const [userType, setUserType] = useState([
    { enum: 'Admin', label: `Admin`, value: 0 },
    { enum: 'Producer', label: `Producer`, value: 1 },
    { enum: 'MediaManager', label: `Media Manager`, value: 2 },
  ]);
  const [selectedUserType, setSelectedUserType] = useState({
    label: `Admin`,
    value: 0,
  });
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    if (!isEmpty(id)) {
      fetchData();
    }
  }, [0]);

  useEffect(() => {
    if (selectedUserType?.value == 1) fetchEvents();
  }, [selectedUserType]);

  useEffect(() => {
    if (data) {
      setFirstName(data.firstName);
      setLastName(data.lastName);
      setEmail(data.email);
      setSelectedUserType(userType.filter((u) => u.enum == data.userType)[0]);
    }
  }, [data]);

  useEffect(() => {
    if (data && eventsOptions != null && eventsOptions.length > 0) {
      let eventsUpdate = data?.events?.$values?.map((e) => {
        const selectItem = eventsOptions.filter((x) => x.value == e)[0];
        return selectItem;
      });
      setEvents(eventsUpdate);
    }
  }, [eventsOptions]);

  const fetchData = async () => {
    await axios
      .post(config.API + "/api/user/getUser", { id })
      .then((res) => {
        setData(res.data);
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message,
          { icon: `error` }
        );
      });
  };

  const fetchEvents = async () => {
    await axios
      .post(config.API + "/api/event/getEventsSelect")
      .then((res) => {
        setEventsOptions(
          res.data.$values.map((x) => {
            return { label: x.name, value: x.id };
          })
        );
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message,
          { icon: `error` }
        );
      });
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (!firstName) setFirstNameError("First Name is required");
    else if (!lastName) {
      setFirstNameError(null);
      setLastNameError("Last Name is required");
    } else if (!id && !email) {
      setLastNameError(null);
      setEmailError("E-mail is required");
    } else if (!id && !password) {
      setEmailError(null);
      setPasswordError("Password is required");
    } else if (!id && !repeatPassword) {
      setPasswordError(null);
      setRepeatPasswordError("Repeat Password is required");
    } else if (password != repeatPassword)
      setRepeatPasswordError("Passwords do NOT match");
    else {
      setRepeatPasswordError(null);

      if (avatar != null) {
        const formData = new FormData();
        formData.append("file", avatar);
        const optionsUpload = {
          headers: { "Content-Type": "multipart/form-data" },
        };

        axios
          .post(config.API + "/api/file/upload", formData, optionsUpload)
          .then((res) => {
            let newUpload = res.data;
            delete newUpload.$id;
            return fetchSave(newUpload);
          })
          .catch(function (error) {
            return AlertComponent(
              "Error",
              error?.response?.data?.error || error?.message,
              { icon: `error` }
            );
          });
      } else {
        return fetchSave(data?.picture);
      }
    }
  };

  const fetchSave = async (picture) => {
    await axios
      .post(config.API + "/api/user/saveInternalUser", {
        id,
        firstName,
        lastName,
        email,
        password,
        userType: selectedUserType.value,
        events: events?.map((e) => e.value),
        picture,
      })
      .then((res) => {
        if (res.status === 200) {
          AlertComponent(
            "Success",
            `User ${id ? "updated" : "created"} successfully`
          );
          return navigate("/users", { replace: false });
        } else
          return AlertComponent("Error", res.data.message || res.data.error, {
            icon: `error`,
          });
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message,
          { icon: `error` }
        );
      });
  };

  return (
    <>
      <Row>
        <Col md={5} className="mt-4">
          <div className="cc-card " >
            <h5>Adding New User</h5>
            <form onSubmit={handleSave}>
              <Row>
                <Col md={12} className="d-flex justify-content-center pb-4">
                  <FieldProfileUpload
                    previewUrl={data?.picture != null
                      ? config.API +
                      "/api/file/download/?guid=" +
                      data.picture.guidFile
                      : null}
                    onChange={setAvatar}
                    className="upload-picture"
                    style={{
                      width: 120,
                      height: 120,
                      minWidth: 120,
                      minHeight: 120,
                      display: "flex",
                    }} />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FieldText
                    label="First Name"
                    type="text"
                    onChange={(x) => setFirstName(x.target.value)}
                    placeholder="First Name"
                    value={firstName}
                    error={firstNameError}
                    required={true}
                    inputClassName={`inputOption`}
                  />
                </Col>
                <Col md={6}>
                  <FieldText
                    label="Last Name"
                    type="text"
                    onChange={(x) => setLastName(x.target.value)}
                    placeholder="Last Name"
                    value={lastName}
                    error={lastNameError}
                    required={true}
                    inputClassName={`inputOption`}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="col-md-12">
                  <FieldText
                    label="E-mail"
                    type="email"
                    onChange={(x) => setEmail(x.target.value)}
                    placeholder="Username"
                    value={email}
                    error={emailError}
                    required={true}
                    readonly={id}
                    inputClassName={`inputOption`} />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FieldText
                    label="Password"
                    type="password"
                    placeholder="Password"
                    onChange={(x) => setPassword(x.target.value)}
                    value={password}
                    error={passwordError}
                    required={!id}
                    inputClassName={`inputOption passwordInput`} />
                </Col>
                <Col md={6}>
                  <FieldText
                    label="Repeat Password"
                    type="password"
                    placeholder="Repeat Password"
                    onChange={(x) => setRepeatPassword(x.target.value)}
                    value={repeatPassword}
                    error={repeatPasswordError}
                    required={!id}
                    inputClassName={`inputOption passwordInput`} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FieldSelect
                    label={`User Type`}
                    options={userType}
                    className={`col-md-12`}
                    onChange={setSelectedUserType}
                    value={selectedUserType}
                    placeholder={`Choose the user type`}
                    required={true} />
                </Col>
              </Row>
              <Row>
                <Col md={12} className="d-flex justify-content-end">
                  <Button type="submit" className="dark-btn mt-4"> Save</Button>
                </Col>
              </Row>
            </form>
          </div>
        </Col>
        <Col md={4} className="mt-4">
          <div className="cc-card">
            <h5>Events Access</h5>
            {selectedUserType.value === 0 && (
              <div className="permissions-messages">
                Permissions are only applied to <b>producers</b>
              </div>
            )}
            {(selectedUserType.value === 1) && (
              <FieldSelect
                label={`Allowed to control these events`}
                options={eventsOptions}
                className={`col-md-12`}
                id={`eventsIds`}
                name={`eventsIds`}
                onChange={setEvents}
                value={events}
                multiple={true}
                required={true} />
            )}
          </div>

        </Col>
      </Row>

    </>
  );
}

export default UserDetail;
